module.exports = __webpack_public_path__ + "img/tq.4492de76.png";